var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClinicalPathways(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 12,
    x: 22,
    fill: "#92d149",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    x: 23,
    y: 19,
    fill: "#92d149",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    x: 6,
    y: 19,
    fill: "#ee3a48",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    y: 48,
    fill: "#92d149",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 14,
    y: 48,
    fill: "#ee3a48",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    x: 40,
    y: 19,
    fill: "#ee3a48",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 34,
    y: 48,
    fill: "#92d149",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 48,
    y: 48,
    fill: "#ee3a48",
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 9a1 1 0 01-.707-.293l-1-1a1 1 0 111.414-1.414l.185.185L30.2 3.4a1 1 0 111.6 1.2l-3 4a1 1 0 01-.729.4zM28 28a1 1 0 01-.707-.293l-1-1a1 1 0 011.414-1.414l.185.185L30.2 22.4a1 1 0 111.6 1.2l-3 4a1 1 0 01-.729.4zM5 55a1 1 0 01-.6-.2l-.574-.434a1 1 0 01.769-1.784l.513-1.027a1 1 0 111.79.894l-1 2a1 1 0 01-.666.527A1.058 1.058 0 015 55zM39 55a1 1 0 01-.6-.2l-.574-.434a1 1 0 01.769-1.784l.513-1.027a1 1 0 011.79.894l-1 2a1 1 0 01-.666.527A1.058 1.058 0 0139 55zM14.707 22.293a1 1 0 00-1.414 0L12 23.586l-1.293-1.293a1 1 0 00-1.414 1.414L10.586 25l-1.293 1.293a1 1 0 101.414 1.414L12 26.414l1.293 1.293a1 1 0 001.414-1.414L13.414 25l1.293-1.293a1 1 0 000-1.414zM20.707 51.293a1 1 0 00-1.414 0l-.293.293-.293-.293a1 1 0 00-1.414 1.414l.293.293-.293.293a1 1 0 101.414 1.414l.293-.293.293.293a1 1 0 001.414-1.414L20.414 53l.293-.293a1 1 0 000-1.414zM48.707 22.293a1 1 0 00-1.414 0L46 23.586l-1.293-1.293a1 1 0 00-1.414 1.414L44.586 25l-1.293 1.293a1 1 0 101.414 1.414L46 26.414l1.293 1.293a1 1 0 001.414-1.414L47.414 25l1.293-1.293a1 1 0 000-1.414zM54.414 53l.293-.293a1 1 0 00-1.414-1.414l-.293.293-.293-.293a1 1 0 00-1.414 1.414l.293.293-.293.293a1 1 0 101.414 1.414l.293-.293.293.293a1 1 0 001.414-1.414z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#21475e",
    d: "M28 12h2v7h-2zM13 19V8a1 1 0 011-1h8V5h-8a3 3 0 00-3 3v11zM47 19V8a3 3 0 00-3-3h-8v2h8a1 1 0 011 1v11zM20 42v6h-2v-6H6v6H4v-6a2.006 2.006 0 012-2h5v-9h2v9h5a2.006 2.006 0 012 2zM54 42v6h-2v-6H40v6h-2v-6a2.006 2.006 0 012-2h5v-9h2v9h5a2.006 2.006 0 012 2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalPathways);
export default __webpack_public_path__ + "static/media/clinicalPathways.53f6f377.svg";
export { ForwardRef as ReactComponent };